window.addEventListener('load', function() {
  
  var mapsContainer = document.querySelector( '#prestaMap' );
  if ( mapsContainer != null ) {
    initMap();
  }
});

// Initialize the map.
function initMap() {
  const mapVars   = window.AppConfig;
  
  if ( undefined == google ) 
    return;

  if ( undefined == mapVars ) 
    return;
  
  var allMarkers = [];
  var infowindow = undefined != google ? new google.maps.InfoWindow() : null;

  const mapZoom   = mapVars.mapZoom;
  const mapPoints = mapVars.mapPoints;

  const mapCenter = new google.maps.LatLng( mapVars.mapCenter.lat, mapVars.mapCenter.lng );
  
  var bounds = new google.maps.LatLngBounds();
  
  // The map, centered at Uluru
  const map = new google.maps.Map(document.getElementById("prestaMap"), {
    zoom: mapZoom,
    center: mapCenter,
  });
  

  if ( mapPoints.length >= 1 ) {
    // Add markers to the map.
    for ( var i = 0; i < mapPoints.length; i++ ) {
      var marker = new google.maps.Marker({
        position: new google.maps.LatLng( mapPoints[i].latLng['lat'], mapPoints[i].latLng['lng'] ),
        map: map,
        icon: ch_js.gMaps.marker,
        providerID: mapPoints[i]['id'],
        providerMapMarkerDatas: mapPoints[i]['providerMapMarkerDatas'],
      });
      
      // Fill a marker list in order to interacting with it later.
      allMarkers.push( marker );
        
      // Extend the bounds to include each marker's position
      bounds.extend(marker.position);
      
      // Listen event on a marker in order to display the right provider card.
      google.maps.event.addListener( marker, 'click', ( function( marker, i ) {
        return function() {
          // Display informations above the marker on the map.
          infowindow.setContent( mapPoints[i]['providerMapMarkerDatas'] );
          infowindow.open( map, marker );
        }
      } )( marker, i ) );
    }
    
    //now fit the map to the newly inclusive bounds
    map.fitBounds(bounds);
  }

  return map;
}